// The choices an expense line offers. One list, used by the item form, the bulk import and the
// receipt reader (the server accepts the same currencies, see backend/src/services/currencyService.js).
export const CATEGORIES = [
    'Travel',
    'Meals',
    'Office Supplies',
    'Accommodation',
    'Transportation',
    'Communication',
    'Other'
];

export const CURRENCIES = [
    'USD', 'EUR', 'GBP', 'INR', 'JPY', 'AUD', 'CAD', 'SGD', 'CHF', 'AED', 'CNY', 'HKD', 'NZD', 'SEK', 'NOK', 'DKK', 'ZAR', 'BRL'
];

// Limits the server enforces (backend/src/controllers/expenseController.js); the screens check them first.
export const MAX_ITEMS = 50;
export const MAX_MONEY = 100000000;
export const MAX_RECEIPT_CHARS = 7000000; // about 5 MB of file once base64-encoded
